export default __webpack_public_path__ + "static/media/DouglasLopes_10.a591c014.jpg";